<!-- TODO Ionic removal: think about using a card component here instead of ui-section -->
@if (typicalWeekStateLikeData()) {
    <ui-section class="width-100">
        <ui-section-content>
            <div class="title-row">
                <edit-text
                    [disabled]="!(tileConfig.hasTileAdminAccess$ | async)"
                    [(ngModel)]="tileData.name"
                    (ngModelChange)="updateTileName()"
                />
                <div class="action-buttons">
                    @if (tileConfig.hasTileAdminAccess$ | async) {
                        <ui-icon-button iconName="delete" size="small" (click)="deleteTile($event)" />
                    }
                </div>
            </div>
            <typical-weeks-chart [periods]="mappedTypicalWeeksData().periods" [timeseriesId]="mappedTypicalWeeksData().timeseriesId" />
        </ui-section-content>
    </ui-section>
}
